import { notification_color_keys, useNotifications } from "utils/hooks";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";
import useCustomQueryClient from "data/modules/api/hooks/useQueryClient";
import { SOMETHING_WENT_WRONG } from "constants/displayStrings";
import { CREATE_CUSTOM_COLUMN } from "../constants/CustomColumns.api";
import { useAddCustomColumnModal } from "../../AddCustomColumnModal/utils/useAddCustomColumnModal";
import { getCustomColumnQueryKey } from "./customColumnQueryKeys";

export const useCreateCustomColumn = ({ sectionName }) => {
  const queryClient = useCustomQueryClient();
  const { notify } = useNotifications();
  const { closeAddCustomColumnModal } = useAddCustomColumnModal();

  return useCustomMutation({
    url: CREATE_CUSTOM_COLUMN,
    onSuccess: () => {
      notify("Column Added Successfully!", notification_color_keys.success);
      queryClient.invalidateQueries({
        queryKey: getCustomColumnQueryKey({ section_name: sectionName }),
      });
      closeAddCustomColumnModal();
    },
    onError: (err) => {
      notify(
        err?.response?.data?.message || SOMETHING_WENT_WRONG,
        notification_color_keys.error
      );
    },
  });
};
